import React, { useEffect, useState, useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import Header from '../../Shell/Header'
import MainContent from '../../Shell/MainContent/MainContent'
import { getAuthorizationDataAction } from '../../security/actions'
import { openSpinnerAction, closeSpinnerAction } from 'context/reducers/openSpinnerReducer'
import HttpClient from 'services/HttpClient'
import { logoutUser } from 'actions/loginActions'
import { useStateValue } from 'context/store'
import siteHeaderSvg from 'images/site-policies-header-img.svg'
import welcomeSvg from 'images/welcome.svg'
import logoZonaSer from 'images/zona ser.png'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAlert from '@material-ui/lab/Alert'
import {
   withStyles,
   Button,
   Modal,
   Backdrop,
   CircularProgress,
   AccordionDetails,
   Typography,
   Snackbar
} from '@material-ui/core'

import { makeStyles, CssBaseline, Grid } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   root: {
      display: 'flex',
      height: '100%'
   },
   container: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#E5E5E5',
      flex: '1 1 auto',
      alignItems: 'center',
      paddingTop: '50px'
   },
   header: {
      display: 'flex',
      maxWidth: '914px',
      fontSize: '16px'
   },
   headerLeft: {
      paddingRight: '100px',
      userSelect: 'none',
      '&> h1': {
         color: '#013F8C',
         fontSize: 24
      }
   },
   content: {
      maxWidth: '1075px'
   },
   accordionTitle: {
      fontWeight: 'bold',
      fontSize: '13px'
   },
   accordionDetails: {
      fontSize: '13px',
      lineHeight: '20px'
   },
   paper: {
      position: 'absolute',
      width: 508,
      height: 380,
      backgroundColor: theme.palette.background.paper,
      borderTop: '3px solid #1665D8',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      display: 'flex',
      flexDirection: 'column',
      fontSize: 14,
      alignItems: 'center',
      textAlign: 'center',
      '&:focus': {
         outline: 'none'
      }
   },
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   welcomeText: {
      marginBottom: '-20px',
      color: '#013F8C',
      fontWeight: 'bold',
      fontSize: '22px',
      lineHeight: '19px'
   },
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
   },
   buttonAcceptSnackbar: {
      color: 'white',
      border: '1px solid white',
      margin: '0 10px',
      '&:hover': {
         borderColor: 'white'
      }
   },
   snackbar: {
      width: '100%',
      top: '64px',
      '&> div': {
         display: 'flex',
         alignItems: 'center',
         minWidth: '100%',
         justifyContent: 'left'
      }
   },
   footerButton: {
      margin: '20px 0 10px 10px',
      padding: '10px 40px'
   }
}))

const Accordion = withStyles({
   root: {
      margin: '7px 0',
      borderRadius: '4px',
      boxShadow: 'none',
      '&:not(:last-child)': {
         borderBottom: 0
      },
      '&:before': {
         display: 'none'
      },
      '&$expanded': {
         margin: 'auto'
      }
   },
   expanded: {}
})(MuiAccordion)

const AccordionSummary = withStyles({
   root: {
      backgroundColor: 'rgba(0, 0, 0, .03)',
      boxShadow: '0px 0px 0px rgba(63, 63, 68, 0.05), 0px 1px 3px rgba(63, 63, 68, 0.15)',
      borderBottom: '1px solid transparent',
      marginBottom: -1,
      maxHeight: 44,
      '&$expanded': {
         maxHeight: 44,
         minHeight: 44,
         borderTop: '4px solid #1665D8',
         borderRadius: '4px 4px 0 0',
         marginTop: '7px'
      }
   },
   content: {
      '&$expanded': {
         margin: '12px 0'
      }
   },
   expanded: {}
})(MuiAccordionSummary)

function Alert(props) {
   return <MuiAlert elevation={6} variant="filled" {...props} />
}

const SitePolicies = props => {
   const [expanded, setExpanded] = useState({})
   const [modalOpened, setModalOpened] = useState(false)
   const [snackbarOpened, setSnackbarOpened] = useState({
      open: false,
      vertical: 'top',
      horizontal: 'center'
   })
   const [backdropOpened, setBackdropOpened] = useState(false)
   const [policies, setPolicies] = useState([])
   const { vertical, horizontal, open } = snackbarOpened
   const [{ sessionUser }, dispatch] = useStateValue()
   const userSettings = sessionUser?.settings

   const classes = useStyles()

   const openSnackbar = newValues => {
      setSnackbarOpened({ ...newValues, open: true })
   }

   const handleSnackbarClose = () => {
      setSnackbarOpened({ ...snackbarOpened, open: false })
   }

   const handleChange = key => (event, newExpanded) => {
      setExpanded(prev => ({
         ...prev,
         [key]: !prev[key]
      }))
   }

   const logout = () => {
      logoutUser(dispatch, sessionUser?.token?.refresh_token, props.history)
   }

   const acceptRejectPolicies = accepted => {
      setBackdropOpened(true)
      HttpClient.patch(`${process.env.REACT_APP_AUTHORIZATION_API}/user/policies`, {
         accepted
      })
         .then(response => {
            setBackdropOpened(false)
            accepted ? setModalOpened(true) : openSnackbar({ vertical: 'top', horizontal: 'center' })
         })
         .catch(e => {
            setBackdropOpened(false)
         })
   }

   const handleModalClose = () => {
      setModalOpened(false)
   }

   const handleAcceptedPolicies = useCallback(async () => {
      dispatch(openSpinnerAction())
      dispatch({ type: 'ASK_WELCOME_TOUR' })
      try {
         const entityNit = userSettings?.entity?.nit || ''
         await getAuthorizationDataAction(dispatch, props.history, entityNit)
         setModalOpened(false)
      } catch (error) {
         console.error('Error al obtener datos de autorización:', error)
      } finally {
         dispatch(closeSpinnerAction())
      }
   }, [dispatch, props.history, userSettings])

   const modalMessageBody = (
      <div className={classes.paper}>
         <img src={logoZonaSer} height="30px" alt={'Logo zona ser'} />
         <h2 className={classes.welcomeText}>¡Bienvenido!</h2>
         <img src={welcomeSvg} alt={'Bienvenida'} />
         <p id="simple-modal-description">
            Usted ha aceptado las Políticas del Sitio del Portal Zona Ser. <br /> ¡Bienvenido!
         </p>
         <Button onClick={handleAcceptedPolicies} variant="contained" color="primary">
            CONTINUAR
         </Button>
      </div>
   )

   useEffect(() => {
      if (policies.length === 0) {
         setBackdropOpened(true)
         HttpClient.get(`${process.env.REACT_APP_AUTHORIZATION_API}/user/policies`)
            .then(response => {
               setPolicies(response && response.data)
               setBackdropOpened(false)
            })
            .catch(e => {
               setBackdropOpened(false)
            })
      }
   }, [])

   return (
      <Grid className={classes.root}>
         <CssBaseline />
         <Header />
         <MainContent>
            <Snackbar
               className={classes.snackbar}
               anchorOrigin={{ vertical, horizontal }}
               open={open}
               onClose={handleSnackbarClose}
               onExit={logout}
               key={vertical + horizontal}
            >
               <Alert severity="error">
                  Usted ha RECHAZADO las Políticas del Sitio del Portal Zona SER, por lo anterior NO tiene acceso al
                  mismo
                  <Button onClick={logout} variant="outlined" className={classes.buttonAcceptSnackbar} color="primary">
                     ACEPTAR
                  </Button>
               </Alert>
            </Snackbar>
            <Backdrop className={classes.backdrop} open={backdropOpened}>
               <CircularProgress color="inherit" />
            </Backdrop>
            <Modal
               className={classes.modal}
               disableEscapeKeyDown={true}
               disableBackdropClick={true}
               open={modalOpened}
               onClose={handleModalClose}
               aria-labelledby="simple-modal-title"
               aria-describedby="simple-modal-description"
            >
               {modalMessageBody}
            </Modal>
            <div className={classes.container}>
               <Grid className={classes.header}>
                  <Grid className={classes.headerLeft}>
                     <h1>Políticas del Sitio</h1>
                     Lea cuidadosamente este documento. al usar el portal web de mutual ser acepta estar obligado por
                     los siguientes términos y condiciones. estos términos y condiciones están sujetos a cambio. si
                     usted no está de acuerdo, no utilice este software.
                  </Grid>
                  <Grid>
                     <img src={siteHeaderSvg} width="250px" alt={'encabezado'} />
                  </Grid>
               </Grid>
               {!backdropOpened ? (
                  <Grid className={classes.content}>
                     {policies.map((policie, index) => {
                        return (
                           <Accordion
                              key={policie.id}
                              square
                              expanded={expanded[`key${policie.id}`]}
                              onChange={handleChange(`key${policie.id}`)}
                           >
                              <AccordionSummary
                                 expandIcon={<ExpandMoreIcon />}
                                 aria-controls="panel1d-content"
                                 id="panel1d-header"
                              >
                                 <Typography className={classes.accordionTitle}>
                                    {index + 1}. {policie.name}
                                 </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                 <Typography
                                    dangerouslySetInnerHTML={{
                                       __html: policie.description
                                    }}
                                    className={classes.accordionDetails}
                                 />
                              </AccordionDetails>
                           </Accordion>
                        )
                     })}
                     {!userSettings?.policiesAccepted && (
                        <Grid container direction="row" justify="flex-end" alignItems="center">
                           <Button
                              onClick={() => acceptRejectPolicies(true)}
                              variant="contained"
                              className={classes.footerButton}
                              color="primary"
                           >
                              ACEPTAR
                           </Button>
                           <Button
                              onClick={() => acceptRejectPolicies(false)}
                              variant="outlined"
                              className={classes.footerButton}
                              color="primary"
                           >
                              RECHAZAR
                           </Button>
                        </Grid>
                     )}
                  </Grid>
               ) : (
                  ''
               )}
            </div>
         </MainContent>
      </Grid>
   )
}

export default withRouter(SitePolicies)
